import { useContext } from "react";

import { DynamicFormContext } from "containers/DynamicForm/DynamicFormContext";
import { TApiButtonCommandFn } from "containers/DynamicForm/useButtonCommand";
import { useGroupApi } from "containers/DynamicForm/useGroupApi";
import { useAppDispatch } from "store";

import { find } from "lodash-es";

export const useCreatePiiUpdateRequest = () => {
  const dispatch = useAppDispatch();
  const apiGroupThunk = useGroupApi();
  const { inputs } = useContext(DynamicFormContext);

  const createPiiUpdateRequestCommand: TApiButtonCommandFn = async commandArgs => {
    const blobIdSource = commandArgs?.find(argument => argument.name === "blobIds")?.source;
    const groupApiSource =
      commandArgs?.find(argument => argument.name === "groupApiKey")?.source || "";

    // find directUploadInput.signedBlobIds by input.key === argument.source;
    const signedBlobIds = find(inputs, { key: blobIdSource })?.value;

    const createPiiUpdateRequestThunk = apiGroupThunk(groupApiSource, { blobIds: signedBlobIds });

    if (createPiiUpdateRequestThunk) {
      return await dispatch(createPiiUpdateRequestThunk).unwrap();
    }
  };

  return createPiiUpdateRequestCommand;
};
